module.exports = __webpack_public_path__ + "dingbeauty/admin/img/user_dbpic.1857db6f.svg";